const ticketQueryDelimiter = /\s*---[\s\S]*?---/;
const ticketQueryMetadataPattern = /---\s*(.+?)\s*-\s*(.+?)---/;

export const TICKET_QUERY_ANSWER_PREVIEW_LENGTH = 40;

export type TicketQueryMetadata = {
    dateTime: string;
    userName: string;
};

/** Strips timestamp/user footer blocks from ticket query question or answer text. */
export function stripTicketQueryContent(text?: string | null): string {
    if (!text) return "";
    const delimiterIndex = text.search(ticketQueryDelimiter);
    return (delimiterIndex >= 0 ? text.slice(0, delimiterIndex) : text).trim();
}

/** Short preview for list rows (collapses line breaks, adds ellipsis). */
export function truncateTicketQueryPreview(text: string, maxLength = TICKET_QUERY_ANSWER_PREVIEW_LENGTH): string {
    const normalized = text.replace(/\s+/g, " ").trim();
    if (normalized.length <= maxLength) return normalized;
    return `${normalized.slice(0, maxLength).trimEnd()}…`;
}

/** Reads the first ---date - user--- block (question timestamp or latest answer). */
export function extractTicketQueryMetadata(text?: string | null): TicketQueryMetadata | null {
    if (!text) return null;

    const match = text.match(ticketQueryMetadataPattern);
    if (!match) return null;

    const dateTime = match[1].trim().replace(
        /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}):\d{2}/,
        "$1"
    );

    return {
        dateTime,
        userName: match[2].trim(),
    };
}

export function formatTicketQueryMetadata(metadata: TicketQueryMetadata | null): string {
    if (!metadata) return "";
    return `${metadata.dateTime} - ${metadata.userName}`;
}
